import React from "react";
import { useUserInfo } from "@/contexts/UserInfoContext";
import styles from "./StateDropdown.module.css";

const US_STATES = [
  { code: "usal", name: "Alabama" },
  { code: "usak", name: "Alaska" },
  { code: "usaz", name: "Arizona" },
  { code: "usar", name: "Arkansas" },
  { code: "usca", name: "California" },
  { code: "usco", name: "Colorado" },
  { code: "usct", name: "Connecticut" },
  { code: "usde", name: "Delaware" },
  { code: "usfl", name: "Florida" },
  { code: "usga", name: "Georgia" },
  { code: "ushi", name: "Hawaii" },
  { code: "usid", name: "Idaho" },
  { code: "usil", name: "Illinois" },
  { code: "usin", name: "Indiana" },
  { code: "usia", name: "Iowa" },
  { code: "usks", name: "Kansas" },
  { code: "usky", name: "Kentucky" },
  { code: "usla", name: "Louisiana" },
  { code: "usme", name: "Maine" },
  { code: "usmd", name: "Maryland" },
  { code: "usma", name: "Massachusetts" },
  { code: "usmi", name: "Michigan" },
  { code: "usmn", name: "Minnesota" },
  { code: "usms", name: "Mississippi" },
  { code: "usmo", name: "Missouri" },
  { code: "usmt", name: "Montana" },
  { code: "usne", name: "Nebraska" },
  { code: "usnv", name: "Nevada" },
  { code: "usnh", name: "New Hampshire" },
  { code: "usnj", name: "New Jersey" },
  { code: "usnm", name: "New Mexico" },
  { code: "usny", name: "New York" },
  { code: "usnc", name: "North Carolina" },
  { code: "usnd", name: "North Dakota" },
  { code: "usoh", name: "Ohio" },
  { code: "usok", name: "Oklahoma" },
  { code: "usor", name: "Oregon" },
  { code: "uspa", name: "Pennsylvania" },
  { code: "usri", name: "Rhode Island" },
  { code: "ussc", name: "South Carolina" },
  { code: "ussd", name: "South Dakota" },
  { code: "ustn", name: "Tennessee" },
  { code: "ustx", name: "Texas" },
  { code: "usut", name: "Utah" },
  { code: "usvt", name: "Vermont" },
  { code: "usva", name: "Virginia" },
  { code: "uswa", name: "Washington" },
  { code: "uswv", name: "West Virginia" },
  { code: "uswi", name: "Wisconsin" },
  { code: "uswy", name: "Wyoming" },
];

export const StateDropdown: React.FC<{
  value?: string;
  onChange: (code: string) => void;
  placeholder?: string;
}> = ({ value, onChange, placeholder }) => {
  const { region, country } = useUserInfo();
  if (region || country !== 'US') return null;
  return (
    <div className={styles.dropdownWrapper}>
      <select
        id="state-dropdown"
        className={value ? `${styles.select} ${styles.hasValue}` : styles.select}
        value={value || ""}
        onChange={e => onChange(e.target.value)}
        required
        aria-label="Select your state"
        aria-describedby="state-dropdown-description"
      >
        <option value="" disabled>
          {placeholder || "State"}
        </option>
        {US_STATES.map(state => (
          <option key={state.code} value={state.code}>
            {state.name}
          </option>
        ))}
      </select>
      <div id="state-dropdown-description" style={{display: 'none'}}>
        Select your state
      </div>
    </div>
  );
}; 